import React from 'react';
import { CtaButton } from './CtaButton';
const formatos = ['Actividades', 'Casos', 'Debates', 'Reflexiones', 'Dinámicas', 'Producciones', 'Jornadas', 'Orientaciones docentes'];
export function IntroSection() {
  return <section className="w-full bg-ink-800 px-4 py-10 text-cream sm:px-8 sm:py-14" data-id="element-89" data-mp="3f67bb43bb4sp">
      <div className="mx-auto max-w-4xl" data-id="element-90" data-mp="3k7eib0xmrzyb">
        <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-gold-400 sm:text-sm sm:tracking-[0.18em]" data-id="element-91" data-mp="3k48x3ws4hi7v">
          La solución
        </p>
        <h2 className="mt-2 font-display text-2xl font-extrabold leading-tight sm:mt-3 sm:text-4xl" data-id="element-92" data-mp="3t5qfxmwwzy09">
          Una biblioteca educativa completa para acompañar la adolescencia desde
          múltiples dimensiones
        </h2>

        <p className="mt-3 font-sans text-sm leading-relaxed text-cream-200 sm:mt-4 sm:text-lg" data-id="element-93" data-mp="6tjjw4hm0v7d">
          El Mega Pack Adolescencia Integral reúne en un único recurso digital
          propuestas prácticas para trabajar identidad, autoestima, vínculos,
          consentimiento, violencia, bullying, diversidad, ciudadanía digital,
          redes sociales, salud mental, toma de decisiones y proyecto de vida.
        </p>

        <p className="mt-4 border-l-2 border-gold pl-3 font-sans text-sm leading-relaxed text-cream sm:pl-4 sm:text-lg" data-id="element-94" data-mp="b33e0q0jag5c">
          No es un conjunto de textos teóricos: son recursos pensados para
          llevar directamente al aula.
        </p>

        <ul className="mt-5 flex flex-wrap gap-1.5 sm:gap-2" data-id="element-95" data-mp="13rirh840oqek">
          {formatos.map(formato => <li key={formato} className="rounded-full bg-ink-900 px-3 py-1.5 font-sans text-xs font-semibold text-cream-200 sm:text-sm" data-id="element-96" data-mp="ytzcg5zhw9lk">
              {formato}
            </li>)}
        </ul>

        <div className="mt-6 max-w-md sm:mt-8" data-id="element-97" data-mp="1mjbmf82nclox">
          <CtaButton data-id="element-98" data-mp="1mk355ib5aoxs">Quiero acceder al Mega Pack</CtaButton>
        </div>
      </div>
    </section>;
}